<template>
    <div
        v-show="show"
        @keyup.esc="onEsc"
        class="fixed z-10 overflow-y-auto top-0 w-full left-0"
        tabindex="-1"
    >
        <div class="flex items-center justify-center min-height-100vh pt-4 px-4 pb-20 text-center sm:block sm:p-0">
            <div
                class="fixed inset-0 transition-opacity"
                @click="onClickMask"
            >
                <div class="absolute inset-0 bg-gray-900 opacity-75" />
            </div>

            <span class="hidden sm:inline-block sm:align-middle sm:h-screen">&#8203;</span>

            <div
                class="px-[20px] pt-[60px] pb-[20px] inline-block align-center bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full"
                role="dialog"
                aria-modal="true"
                aria-labelledby="modal-headline"
            >
                <span
                    v-if="closeBtn"
                    class="absolute top-[15px] right-[15px] cursor-pointer"
                    @click="$emit('close')"
                >
                    Stäng
                </span>

                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
    import { } from 'vue'

    export default {
        props: {
            closeBtn: {
                type: Boolean,
                required: false,
                default: true
            },
            show: {
                type: Boolean,
                required: true,
            },
            transparent: {
                type: Boolean,
                required: false
            },
            size: {
                type: String,
                default: 'small'
            }
        },
        setup(props, { emit }) {
            const close = () => emit('close')
            const onEsc = () => emit('close')
            const onClickMask = () => emit('close')

            return {
                close,
                onEsc,
                onClickMask
            }
        }
    }
</script>
